import { executeCapability } from '../utils/capabilityExecute'

export interface PlatformContentItem {
  version: string;
  content: string;
  updatedAt: string | null;
}

export interface PlatformContentData {
  tos: PlatformContentItem;
  privacy: PlatformContentItem;
  updates: PlatformContentItem;
}

export const platformContentService = {
  async getAll(): Promise<PlatformContentData> {
    return executeCapability<PlatformContentData>({
      app: 'admin',
      capability: 'admin.platformContent.getAll',
      input: {},
    })
  },

  async update(type: 'tos' | 'privacy' | 'updates', version: string, content: string): Promise<PlatformContentItem> {
    return executeCapability<PlatformContentItem>({
      app: 'admin',
      capability: 'admin.platformContent.update',
      input: { type, version, content },
    })
  },
};
